import { collapseConversation, expandConversation } from './ConversationHeaderIcons.locstring.json';
import loc from 'owa-localize';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ConversationAttachmentWellButton } from 'owa-attachment-conversation-well-view';
import { ControlIcons } from 'owa-control-icons';
import expandCollapseAllItemParts from 'owa-mail-reading-pane-store/lib/actions/expandCollapseAllItemParts';
import ConversationReadingPaneViewState from 'owa-mail-reading-pane-store/lib/store/schema/ConversationReadingPaneViewState';
import readingPaneStore from 'owa-mail-reading-pane-store/lib/store/Store';
import isAllItemPartsExpanded from 'owa-mail-reading-pane-store/lib/utils/isAllItemPartsExpanded';
import canConversationLoadMore from 'owa-mail-store/lib/utils/canConversationLoadMore';

import * as React from 'react';

const conversationStyles = require('./ConversationReadingPane.scss');

export interface ConversationHeaderIconsProps {
    conversationId: string;
}

@observer
export default class ConversationHeaderIcons extends React.Component<
    ConversationHeaderIconsProps,
    {}
> {
    @computed
    get getIsAllItemPartsExpanded(): boolean {
        return isAllItemPartsExpanded();
    }

    render() {
        const { conversationReadingPaneViewState } = readingPaneStore;
        const canLoadMore: boolean = canConversationLoadMore(this.props.conversationId);
        const attachmentWell = this.renderAttachmentWell(
            conversationReadingPaneViewState,
            canLoadMore
        );
        const expCollConversationButton = this.renderExpCollConversationButton(
            conversationReadingPaneViewState
        );

        if (attachmentWell || expCollConversationButton) {
            return (
                <div className={conversationStyles.headerIconsContainer}>
                    {attachmentWell}
                    {expCollConversationButton}
                </div>
            );
        }

        return null;
    }

    private renderAttachmentWell(
        selectedConversationReadingPaneState: ConversationReadingPaneViewState,
        canLoadMore: boolean
    ): JSX.Element {
        if (selectedConversationReadingPaneState?.attachmentWell) {
            return (
                <ConversationAttachmentWellButton
                    viewState={selectedConversationReadingPaneState.attachmentWell}
                    canLoadMore={canLoadMore}
                    instrumentationContext={
                        selectedConversationReadingPaneState.instrumentationContext
                    }
                />
            );
        }
        return null;
    }

    private renderExpCollConversationButton(
        selectedConversationReadingPaneState: ConversationReadingPaneViewState
    ): JSX.Element {
        if (
            selectedConversationReadingPaneState?.itemPartsMap &&
            selectedConversationReadingPaneState.itemPartsMap.size > 1
        ) {
            return this.getIsAllItemPartsExpanded ? (
                <IconButton
                    title={loc(collapseConversation)}
                    ariaLabel={loc(collapseConversation)}
                    onClick={this.onCollapseConversationClicked}
                    iconProps={{ iconName: ControlIcons.CollapseContent }}
                    className={conversationStyles.expCollConversationButton}
                />
            ) : (
                <IconButton
                    title={loc(expandConversation)}
                    ariaLabel={loc(expandConversation)}
                    onClick={this.onExpandConversationClicked}
                    iconProps={{ iconName: ControlIcons.ExploreContent }}
                    className={conversationStyles.expCollConversationButton}
                />
            );
        }

        return null;
    }

    private async onExpandConversationClicked() {
        expandCollapseAllItemParts(true /*shouldExpand*/, false /*isFromShortcut*/);
    }

    private async onCollapseConversationClicked() {
        expandCollapseAllItemParts(false /*shouldExpand*/, false /*isFromShortcut*/);
    }
}
